var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { getCoreRowModel, getExpandedRowModel, getFilteredRowModel, getPaginationRowModel, getSortedRowModel, useReactTable, } from "@tanstack/react-table";
import { Box } from "../../Box";
// Default table cell, displays value as string with standard padding and style
const defaultColumnDef = {
    cell: (props) => React.createElement(Box, null, String(props.getValue())),
    maxSize: Number.MAX_SAFE_INTEGER,
    minSize: 0, // Must be 0 because this is an index into the theme.sizes array
    size: 150,
};
// TODO: Probably a separate wrapper for client-side pagination/sorting/filtering
//       vs. server-side? (server side requires managed state outside this hook,
//       so possibly we provide helper hooks for that?)
// TODO: Need to add "alphanumeric" as the sortingFn for all string columns
/**
 * A wrapper around the useReactTable hook that provides some default table configuration options.
 */
export function useTableV2(_a) {
    // TODO: Determine if this manual pagination workaround is still required:
    // https://github.com/TanStack/react-table/issues/2321
    var { enableSortingRemoval = false, enableMultiSort = false, sortDescFirst = false, // https://github.com/TanStack/table/issues/5147
    enablePagination = false, autoResetPageIndex = false, enableSorting = false, defaultColumn = defaultColumnDef } = _a, rest = __rest(_a, ["enableSortingRemoval", "enableMultiSort", "sortDescFirst", "enablePagination", "autoResetPageIndex", "enableSorting", "defaultColumn"]);
    /* eslint-disable sort-keys-fix/sort-keys-fix */
    return useReactTable(Object.assign({ enableSortingRemoval,
        enableMultiSort,
        sortDescFirst,
        enableSorting,
        defaultColumn,
        autoResetPageIndex, getCoreRowModel: getCoreRowModel(), getSortedRowModel: getSortedRowModel(), getPaginationRowModel: enablePagination ? getPaginationRowModel() : undefined, getExpandedRowModel: getExpandedRowModel(), getFilteredRowModel: getFilteredRowModel() }, rest));
}
